<script>
import {getAction, httpAction} from "@/utils/api/manages";

export default {
  name: "menus",
  props: {
    type: String,
  },
  data() {
    return {
      // 一级分类
      oneClassify: [],
      productCategoryId: null,
      productMainTypeId: null,
      oneHoverActive: null,
      // 定时器
      timer: null,
      selectOption: [],
      // 固定菜单
      staticMenus: [
        {dictValue: null, dictLabel: '全部产品', count: 0},
        {dictValue: 2, dictLabel: 'SASS', count: 0},
        {dictValue: 1, dictLabel: '私有部署', count: 0},
        {dictValue: 3, dictLabel: '专业服务', count: 0},
      ],
      // 一级导航名称
      oneClassifyName: null,
      // 二级导航名称
      twoClassifyName: null,
      // 二级菜单内容
      twoClassifyData: null,
    }
  },
  created() {
    this.getOneClassify()
    this.getAllCount()
    const {productCategoryId, productMainTypeId} = this.$route.query
    this.productCategoryId = productCategoryId
    this.productMainTypeId = productMainTypeId
  },
  watch: {
    // 监听type
    type(val) {
      this.getOneClassify()
      this.getAllCount()
      this.reset()
    }
  },
  methods: {
    // 获取一级分类
    getOneClassify() {
      getAction(`/basics/productmaintype/${this.type}/null`).then(res => {
        if (res.code !== 200) return;
        this.oneClassify = res.data
        this.oneClassify.forEach(item => {
          item.children = []
        })
        if (this.productMainTypeId) {
          const index = this.oneClassify.findIndex(item => item.dictValue === this.productMainTypeId)
          if (index === -1) return
          this.oneClassifyName = this.oneClassify[index].dictLabel
          if (this.productCategoryId) {
            this.getTwoClassify(this.oneClassify[index].dictValue, index)
          } else {
            this.setMenuName()
          }
        }
      })
    },
    // 获取二级分类
    getTwoClassify(productMainTypeId, index) {
      httpAction({
        url: `/product/categoryandtag/all`,
        method: 'get',
        params: {
          productMainTypeId,
          createFlag: this.type,
        },
        noToken: true,
      }).then(res => {
        this.selectOption = res.data
        this.oneClassify.at(index).children = res.data
        if (this.productCategoryId) {
          let optionsData = res.data.find(item => item.productCategoryId === this.productCategoryId)
          if (!optionsData) return
          this.twoClassifyName = optionsData.categoryName
          this.twoClassifyData = optionsData
          const type1 = `IT评测，IT产品，基础架构，运维,devops,IDC，工具软件，管理软件，数据库，操作系统，网络，安全，存储,中间件，虚拟化，云计算，超融合，点评，选型，采购`
          const type2 = `，IT采购`
          this.$store.commit('CAHNGE_META_INFO', {
            title: this.twoClassifyName + "评测及选型,qidao123.com--IT企服评测应用市场",
            keywords: this.twoClassifyName + this.type === '1' ? type1 : type1 + type2,
            description: this.twoClassifyData.remark.slice(0,300)
          })
          this.setMenuName()
        }
      })
    },
    // 鼠标移入
    mouseenterAllClassifyTag(index, item) {
      clearTimeout(this.timer)
      this.selectOption = []
      this.timer = setTimeout(() => {
        this.oneHoverActive = index
        let children = this.oneClassify.at(index - 1).children
        if (children.length) {
          this.selectOption = children
        } else {
          this.getTwoClassify(item.dictValue, index - 1)
        }
      }, 800)
    },
    // 鼠标移开
    leaveTwoClassify() {
      clearTimeout(this.timer)
      this.timer = null
      this.selectOption = []
      this.oneHoverActive = null
    },
    productIdChange(item) {
      if (!item) {
        this.productCategoryId = null
        this.twoClassifyName = null
      } else {
        const {productCategoryId, categoryName} = item
        this.productCategoryId = productCategoryId
        this.twoClassifyName = categoryName
        this.twoClassifyData = item
      }
      this.productMainTypeId = this.oneClassify.at(this.oneHoverActive - 1).dictValue
      this.open()
    },
    mainTypeIdChange(item) {
      if (!item) {
        this.productMainTypeId = null
        this.oneClassifyName = null
      } else {
        this.productMainTypeId = item.dictValue
        this.oneClassifyName = item.dictLabel
        if (item.dictValue < 4) this.oneClassifyName = null
      }
      this.twoClassifyName = null
      this.productCategoryId = null
      this.open()
    },
    open() {
      let query = {type: this.type}
      if (this.productCategoryId !== null) query.productCategoryId = this.productCategoryId
      if (this.productMainTypeId !== null) query.productMainTypeId = this.productMainTypeId
      this.$router.replace({
        path: `/product-classify`,
        query
      })
      this.setMenuName()
    },
    reset() {
      this.productMainTypeId = null
      this.productCategoryId = null
      this.oneClassifyName = null
      this.twoClassifyName = null
      this.open()
    },
    setMenuName() {
      let data = {
        twoClassifyName: this.twoClassifyName,
        oneClassifyName: this.oneClassifyName,
        productCategoryId: this.productCategoryId,
        productMainTypeId: this.productMainTypeId,
      }
      if (data.productCategoryId) {
        data.twoClassifyData = this.twoClassifyData
      }
      this.$emit('menuChange', data)
    },
    // 获取全部数量
    async getAllCount() {
      for (let [index, item] of this.staticMenus.entries()) {
        getAction(`basics/productmaintype/${this.type}/${item.dictValue}`).then(res => {
          if (res.code === 200) {
            let count = 0
            res.data.forEach(child => {
              count += child.count
            })
            this.staticMenus.at(index).count = count
          }

        })
      }
    }
  },
  computed: {
    // 获取选中的标签
    selectTop() {
      if (this.oneHoverActive === null) return '0px'
      const multiple = parseInt(this.oneHoverActive / 5)
      return `${multiple * 50 + 50 + multiple * 6}px`
    }
  }
}
</script>

<template>
  <div class="head-list" @mouseleave="leaveTwoClassify">
    <div
        class="list-item top"
        @click="mainTypeIdChange"
        :class="!productMainTypeId ||productMainTypeId<4 ? 'active':null"
        @mouseenter="leaveTwoClassify"
    >
      <div class="box">
        <h2 class="item-name">
          全部产品
        </h2>
        <span class="item-num">{{ staticMenus[0].count }}</span>
        <span>
          <i class="el-icon-caret-bottom icon" v-if="!productMainTypeId ||productMainTypeId<3 "></i>
          <i class="el-icon-caret-top  icon" v-else></i>
        </span>
      </div>
      <div class="mySelect">
        <div class="options" v-for="(item,index) in staticMenus" @click.stop="mainTypeIdChange(item)" :key="index">
          <div class="name">{{ item.dictLabel }}</div>
          <div class="num">{{ item.count }}</div>
          <i class="el-icon-caret-top"></i>
        </div>
      </div>
    </div>
    <div
        class="list-item"
        v-for="(item, index) in oneClassify"
        :key="index"
        @mouseenter="mouseenterAllClassifyTag(index+1, item)"
        :class="productMainTypeId === item.dictValue? 'active':null"
        @click="mainTypeIdChange(item)"
    >
      <div class="box">
        <div class="item-name" v-if="productMainTypeId === item.dictValue">{{ twoClassifyName || item.dictLabel }}</div>
        <div class="item-name" v-else>{{ item.dictLabel }}</div>
        <div class="item-num">{{ item.count }}</div>
        <i class="el-icon-caret-bottom icon" v-if="productMainTypeId === item.dictValue"></i>
        <i class="el-icon-caret-top icon" v-else></i>
      </div>
    </div>
    <div class="item-children"
         v-loading="!selectOption.length"
         @mouseleave="leaveTwoClassify"
         :style="{ top: selectTop}"
         v-show="oneHoverActive || oneHoverActive===0"
    >
      <div class="tag" :class="!productCategoryId && productCategoryId!==0?'active':null"
           @click="productIdChange">
        <h3 class="tag-name">全部</h3>
      </div>
      <div class="tag"
           v-for="(item, index) in selectOption"
           :key="index"
           @click="productIdChange(item)"
           :class="productCategoryId === item.productCategoryId?'active':null"
      >
        <h3 class="tag-name">{{ item.categoryName }} {{ item.count }}</h3>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.head-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 6px;
  position: relative;

  .item-children {
    position: absolute;
    background: #fff;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-shadow: 0 0 11px 0 rgba(0, 0, 0, .16);
    padding: 20px;
    gap: 10px;
    border-radius: 6px;
    border: 1px solid #ddd;
    transition: all .3s;
    z-index: 10;

    .tag {
      padding: 5px 16px;
      border-radius: 3px;
      cursor: pointer;
      background: #f5f5f5;
      color: #666;
      border: 1px solid #f5f5f5;

      &.active {
        background: rgba(235, 84, 18, .05);
        color: var(--swiper-theme-color);
        border-color: var(--swiper-theme-color);
      }

      &:hover {
        background: rgba(235, 84, 18, .05);
        color: var(--swiper-theme-color)
      }

      .tag-name {
        font-size: 14px;
      }
    }
  }

  .list-item {
    box-sizing: border-box;
    cursor: pointer;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F5F5F5;
    border: 1px solid #dadada;
    gap: 2px;
    flex: 0 0 calc(20% - 4.8px);

    &.top {
      position: relative;

      &.active {
        background: var(--swiper-theme-color);
        color: white;

        .box {
          .item-num {
            color: white;
          }
        }

      }

      &:hover {
        .mySelect {
          display: block;
        }
      }

      .mySelect {
        position: absolute;
        top: 100%;
        color: initial;
        width: 100%;
        background-color: #fff;
        display: none;
        z-index: 10;


        .options {
          border: 1px solid #ddd;
          width: 100%;
          line-height: 35px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333;
          gap: 4px;

          .num {
            font-size: 12px;
          }

          &:hover {
            background: rgba(235, 84, 18, .05);
            color: var(--swiper-theme-color);
            border-color: var(--swiper-theme-color);
          }
        }
      }
    }

    &.active {
      background: rgba(235, 84, 18, .05);
      color: var(--swiper-theme-color);
      border-color: var(--swiper-theme-color);

      .box {
        .item-num {
          color: var(--swiper-theme-color);
        }
      }
    }

    .box {
      display: flex;
      gap: 5px;
      align-items: baseline;

      .item-name {
        font-size: 15px;
      }

      .item-num {
        font-size: 12px;
        color: #999;
      }
    }

    &:hover {
      color: var(--swiper-theme-color);

      .item-num {
        color: var(--swiper-theme-color);
      }
    }
  }
}
</style>